module.exports = __webpack_public_path__ + "static/strip2-b8841bbe122aee512eb0b3277007131c.jpg";